// src/services/api.js

// http://localhost:3500/api/auth/login
// https://firma.visioner7.pe/api/auth/login

const API_BASE_URL = "https://firma.visioner7.pe/api";
const API_BASE_FRONT = "https://firma.visioner7.pe";

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.baseURLFront = API_BASE_FRONT;
  }

  // Método para obtener headers con autenticación
  getAuthHeaders(contentType = "application/json") {
    const token = this.getToken();
    const headers = {};

    // Solo agregar Authorization si hay token (para rutas protegidas)
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    if (contentType) {
      headers["Content-Type"] = contentType;
    }

    return headers;
  }

  // Método para rutas públicas (sin Authorization)
  getPublicHeaders(contentType = "application/json") {
    const headers = {};

    if (contentType) {
      headers["Content-Type"] = contentType;
    }

    return headers;
  }

  // Obtener token del localStorage
  getToken() {
    return localStorage.getItem("authToken");
  }

  // Guardar token en localStorage
  setToken(token) {
    localStorage.setItem("authToken", token);
  }

  // Remover token
  removeToken() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
  }

  // Guardar usuario
  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }

  // Obtener usuario
  getUser() {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  }

  
  getSignatureUrl(documentId) {
    return `${this.baseURLFront}/firmar/${documentId}`;
  }


  getVerificationUrl(documentId) {
    return `${this.baseURLFront}/verificar/${documentId}`;
  }


  async request(endpoint, options = {}, isPublic = false) {
    const url = `${this.baseURL}${endpoint}`;

    try {
      const headers = isPublic
        ? this.getPublicHeaders(options.contentType)
        : this.getAuthHeaders(options.contentType);

      const config = {
        ...options,
        headers: {
          ...headers,
          ...options.headers,
        },
      };

      if (
        options.body &&
        typeof options.body === "object" &&
        !(options.body instanceof FormData)
      ) {
        config.body = JSON.stringify(options.body);
      }

      const response = await fetch(url, config);

      if (response.status === 401 && !isPublic) {
        this.removeToken();
        throw new Error("Sesión expirada. Por favor inicia sesión nuevamente.");
      }

      const data = await response.json();

      if (!response.ok) {
        const err = new Error(
          data.error || `Error ${response.status}: ${response.statusText}`,
        );
        err.data = data; 
        err.status = response.status;
        throw err;
      }

      return data;
    } catch (error) {
      //console.error("API Request Error:", error);
      throw error;
    }
  }


  async publicRequest(endpoint, options = {}) {
    return this.request(endpoint, options, true);
  }


async upload(endpoint, formData) {
  const url = `${this.baseURL}${endpoint}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: this.getAuthHeaders(null),
      body: formData,
    });

    if (response.status === 401) {
      this.removeToken();
      throw new Error("Sesión expirada. Por favor inicia sesión nuevamente.");
    }

    //  Manejo específico del error 413 de Nginx (viene como HTML)
    if (response.status === 413) {
      throw Object.assign(new Error("El archivo es demasiado grande. Tamaño máximo permitido: 10 MB."), {
        status: 413
      });
    }

    // Intentar parsear como JSON, pero si falla (HTML de Nginx), lanzar error genérico
    let data;
    try {
      data = await response.json();
    } catch (parseError) {
      // Si no es JSON, probablemente es el HTML de error de Nginx
      throw Object.assign(
        new Error(`Error del servidor (${response.status}). Por favor, intenta con un archivo más pequeño.`),
        { status: response.status }
      );
    }

    if (!response.ok) {
      throw Object.assign(
        new Error(data.error || `Error ${response.status}: ${response.statusText}`),
        { status: response.status, data }
      );
    }

    return data;
  } catch (error) {
    throw error;
  }
}


  async downloadFile(endpoint, filename, isPublic = false) {
    const url = `${this.baseURL}${endpoint}`;

    try {
      const headers = isPublic
        ? this.getPublicHeaders(null)
        : this.getAuthHeaders(null);

      const response = await fetch(url, { headers });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);

      return true;
    } catch (error) {
     // console.error("Download Error:", error);
      throw error;
    }
  }
}

export const apiService = new ApiService();
